// extracted by mini-css-extract-plugin
module.exports = {"root":"_7ea091","featuresCont":"_af4c27","title":"_2287ee","buttonCont":"_2c1899","expandButton":"_b17966","featureHidden":"_e1fb11"};